import React, { Component } from "react";
import "./App.scss";
import Header from "./components/Header";
import Hero from "./components/Hero";
import Stats from "./components/Stats";
import About from "./components/About";
import Projects from "./components/Projects";
import Skills from "./components/Skills";
import Experience from "./components/Experience";
import ExperienceGrid from "./components/ExperienceGrid";
import Footer from "./components/Footer";
import primaryLang from "./data/primaryLang.json";
import secondaryLang from "./data/secondaryLang.json";

const SHARED = {
  basic_info: {
    name: "Jared Flores",
    titles: ["Game Developer", "Front-End Developer"],
    social: [
      { name: "Github",   url: "https://github.com/JaredFG",                                                         class: "fab fa-github"    },
      { name: "Itch.io",  url: "https://jaredfg.itch.io",                                                            class: "fab fa-itch-io"   },
      { name: "Linkedin", url: "https://www.linkedin.com/in/jared-abraham-flores-guarneros-5515a0191/",               class: "fab fa-linkedin"  },
    ],
    image: "Jared.png",
  },
  skills: {
    icons: [
      { name: "HTML 5",     class: "devicon-html5-plain",        level: "80" },
      { name: "CSS 3",      class: "devicon-css3-plain",         level: "65" },
      { name: "JavaScript", class: "devicon-javascript-plain",   level: "70" },
      { name: "Unity",      class: "devicon-unity-plain",        level: "95" },
      { name: "C#",         class: "devicon-csharp-plain",       level: "95" },
      { name: "MySql",      class: "devicon-mysql-plain",        level: "60" },
      { name: "React",      class: "devicon-react-original",     level: "50" },
      { name: "Canva",      class: "devicon-canva-original",     level: "40" },
      { name: "Github",     class: "devicon-github-original",    level: "40" },
      { name: "Python",     class: "devicon-python-plain",       level: "40" },
      { name: "Wordpress",  class: "devicon-wordpress-plain",    level: "70" },
    ],
  },
};

class App extends Component {
  constructor(props) {
    super();
    this.state = {
      resumeData: primaryLang,
      sharedData: SHARED,
      currentLang: "en",
    };
    this.handleLangChange = this.handleLangChange.bind(this);
  }

  componentDidMount() {
    document.title = "Jared Flores | Portfolio";
    setTimeout(() => this.initRevealObserver(), 50);
  }

  componentDidUpdate() {
    this.initRevealObserver();
  }

  handleLangChange(lang) {
    this.setState({
      currentLang: lang,
      resumeData: lang === "en" ? primaryLang : secondaryLang,
    });
    document.documentElement.lang = lang;
  }

  initRevealObserver() {
    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add("in");
            obs.unobserve(e.target);
          }
        });
      },
      { threshold: 0.1 }
    );
    document.querySelectorAll(".rv:not(.in)").forEach((el) => obs.observe(el));
  }

  render() {
    const { resumeData, sharedData, currentLang } = this.state;

    return (
      <div>
        <div id="video-bg">
          <div className="vid-placeholder"></div>
        </div>

        <Header
          sharedData={sharedData.basic_info}
          resumeBasicInfo={resumeData.basic_info}
          onLangChange={this.handleLangChange}
          currentLang={currentLang}
        />

        <Hero resumeBasicInfo={resumeData.basic_info} />

        <Stats resumeBasicInfo={resumeData.basic_info} />

        <About
          resumeBasicInfo={resumeData.basic_info}
          sharedBasicInfo={sharedData.basic_info}
        />

        <Experience
          resumeExperience={resumeData.experience}
          resumeBasicInfo={resumeData.basic_info}
        />

        <Projects
          resumeProjects={resumeData.projects}
          resumeBasicInfo={resumeData.basic_info}
        />

        <Skills
          sharedSkills={sharedData.skills}
          resumeBasicInfo={resumeData.basic_info}
        />

        <ExperienceGrid
          resumeCourses={resumeData.Courses}
          resumeBasicInfo={resumeData.basic_info}
        />

        <Footer sharedBasicInfo={sharedData.basic_info} />
      </div>
    );
  }
}

export default App;
